<button class="button" (click)="GenerateMlArticle()">Open AI Tool</button>